/**
 * Product page: variant picker, gallery (thumbnails + zoom lightbox),
 * and native product recommendations fetch.
 */
(function () {
  'use strict';

  /* ---------------- Variant picker ---------------- */
  var picker = document.querySelector('[data-variant-picker]');
  if (picker) {
    var select = picker.querySelector('[data-variant-select]');
    var jsonSource = document.querySelector('[data-product-json-source]');
    var variants = [];
    if (jsonSource) {
      try {
        variants = JSON.parse(jsonSource.textContent).variants.map(function (v) {
          return { id: v.id, options: v.options, available: v.available };
        });
      } catch (err) { /* fall through to select-based fallback below */ }
    }
    if (!variants.length) {
      variants = Array.prototype.map.call(select.options, function (opt) {
        return { id: opt.value, options: opt.textContent.trim().split(' — ')[0].split(' / '), available: opt.getAttribute('data-available') === 'true' };
      });
    }

    function currentSelections() {
      return Array.prototype.map.call(picker.querySelectorAll('[data-option-index]'), function (group) {
        var selected = group.querySelector('.variant-picker__pill.is-selected');
        return selected ? selected.getAttribute('data-value') : null;
      });
    }

    function syncProductForm(variantId, available) {
      document.querySelectorAll('[data-product-form-variant-id]').forEach(function (input) { input.value = variantId; });
      var addBtn = document.querySelector('[data-add-to-cart]');
      var addText = document.querySelector('[data-add-to-cart-text]');
      if (addBtn) addBtn.disabled = !available;
      if (addText) addText.textContent = available
        ? (window.ElongeStrings && window.ElongeStrings.addToCart) || 'Add to bag'
        : (window.ElongeStrings && window.ElongeStrings.soldOut) || 'Sold out';
      var buyNow = document.querySelector('[data-buy-now]');
      if (buyNow) buyNow.style.display = available ? '' : 'none';
    }

    picker.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-variant-option]');
      if (!pill) return;
      var group = pill.closest('[data-option-index]');
      group.querySelectorAll('.variant-picker__pill').forEach(function (p) { p.classList.remove('is-selected'); });
      pill.classList.add('is-selected');
      group.querySelector('[data-option-selected-value]').textContent = pill.getAttribute('data-value');

      var selections = currentSelections();
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return selections[i] === null || opt === selections[i]; });
      });
      if (match) {
        select.value = match.id;
        syncProductForm(match.id, match.available);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
        document.dispatchEvent(new CustomEvent('elonge:variant-changed', { detail: { variantId: match.id } }));
      }
    });
  }

  /* ---------------- Gallery ---------------- */
  var gallery = document.querySelector('[data-product-gallery]');
  if (gallery) {
    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var currentIndex = 0;

    function showSlide(index) {
      slides.forEach(function (s, i) {
        s.hidden = i !== index;
        s.classList.toggle('is-active', i === index);
      });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      currentIndex = index;
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { showSlide(i); });
    });

    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { showSlide((currentIndex - 1 + slides.length) % slides.length); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showSlide((currentIndex + 1) % slides.length); });

    var lightbox = document.querySelector('[data-gallery-lightbox]');
    var lightboxImg = lightbox ? lightbox.querySelector('[data-gallery-lightbox-image]') : null;
    gallery.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-gallery-zoom-trigger]');
      if (!trigger || !lightbox) return;
      var img = trigger.querySelector('img');
      lightboxImg.src = img.getAttribute('data-zoom-src') || img.src;
      lightboxImg.alt = img.alt;
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
    });
    var lightboxClose = document.querySelector('[data-gallery-lightbox-close]');
    if (lightboxClose) lightboxClose.addEventListener('click', function () {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
    });
  }

  /* ---------------- Product recommendations (native endpoint) ---------------- */
  var recommendationsSection = document.querySelector('[data-product-recommendations]');
  if (recommendationsSection) {
    var url = recommendationsSection.getAttribute('data-url');
    if (url) {
      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newSection = doc.querySelector('[data-product-recommendations]');
          if (newSection && newSection.innerHTML.trim()) {
            recommendationsSection.innerHTML = newSection.innerHTML;
          }
        })
        .catch(function (err) { console.error('[recommendations]', err); });
    }
  }
})();
